import Badge from './Badge';
import type { TicketLabelRef } from '../api/types';
import { formatLabel } from '../utils/ticket';

type Props = {
  labels: TicketLabelRef[];
  /** Max badges before collapsing into "+N more". Default 3. */
  maxVisible?: number;
  badgeClassName?: string;
};

export default function TicketLabelBadges({
  labels,
  maxVisible = 3,
  badgeClassName = 'badge-info',
}: Props) {
  if (labels.length === 0) return null;

  const visible = labels.slice(0, maxVisible);
  const hidden = labels.slice(maxVisible);
  const hiddenTitle = hidden.map((l) => formatLabel(l)).join(', ');

  return (
    <span className="label-badges">
      {visible.map((l) => (
        <Badge key={l.id} label={formatLabel(l)} className={badgeClassName} />
      ))}
      {hidden.length > 0 && (
        <span className="label-badges-more" title={hiddenTitle}>
          +{hidden.length} more
        </span>
      )}
    </span>
  );
}
